import { Link } from "react-router-dom";
import aboutImage from "../../assets/images/gallery-2.jpg";

function AboutPreview() {
    return (
        <section className="about-preview">
            <div className="about-preview-container">
                <div className="about-preview-content">
                    <p className="about-preview-label">Despre sala</p>

                    <h2 className="about-preview-title">
                        Un spatiu creat pentru performanta, disciplina si progres real
                    </h2>

                    <p className="about-preview-text">
                        La Cris Gym Fitness gasesti un mediu modern, echipamente pregatite
                        pentru antrenamente eficiente si o atmosfera care te motiveaza sa
                        revii. Fie ca esti incepator sau ai deja experienta, aici ai tot ce
                        iti trebuie pentru a lucra serios si constant.
                    </p>

                    <div className="about-preview-stats">
                        <div className="about-stat">
                            <h3>Progres</h3>
                            <p>Antrenamente orientate spre rezultate reale</p>
                        </div>

                        <div className="about-stat">
                            <h3>Motivatie</h3>
                            <p>Atmosfera buna si energie potrivita pentru munca</p>
                        </div>
                    </div>

                    <div className="about-preview-actions">
                        <Link to="/despre" className="about-btn primary">
                            Afla mai multe
                        </Link>

                        <Link to="/contact" className="about-btn secondary">
                            Contacteaza-ne
                        </Link>
                    </div>
                </div>

                <div className="about-preview-image-wrapper">
                    <img
                        src={aboutImage}
                        alt="Cris Gym Fitness"
                        className="about-preview-image"
                    />
                </div>
            </div>
        </section>
    );
}

export default AboutPreview;